export const scrollToAnchor = (anchorId, extraOffset = 0) => {
  setTimeout(() => {
    const element = document.getElementById(anchorId);
    if (!element) {
     
      return;
    }

    // 1) Compute the element's absolute Y position in the document
    const absoluteElementTop =
      element.getBoundingClientRect().top + window.pageYOffset;

    // 2) Apply your extraOffset *additively*
    const targetY = absoluteElementTop + extraOffset;

    // 3) Compare to current scroll to figure out direction & distance
    const currentY = window.pageYOffset;
    const delta   = targetY - currentY;
    

    // 4) Smooth-scroll there
    window.scrollTo({ top: targetY, behavior: 'smooth' });

  }, 100);
};